import { useApi } from '@/api';
import type { GetHourlyActivityResponse } from '@/api/handlers/resources/sales/responses/GetHourlyActivityResponse';
import type { ApiResponse } from '@/api/handlers/responses/ApiResponse';
import { useQuery } from '@tanstack/react-query';
import { SalesQueryKeys } from './salesQueryKeys';

export const useHourlyActivityQuery = (enabled = true) => {
    const { apiClient } = useApi();

    return useQuery<ApiResponse<GetHourlyActivityResponse>>({
        queryKey: SalesQueryKeys.hourlyActivity(),
        queryFn: () => apiClient.sales.getHourlyActivity(),
        enabled: enabled,
        staleTime: 60_000,
    });
};
